const app = {
  state: {
    botInfo: {},
    updateBotBaseInfo: {}
  },
  mutations: {
    updateBotInfo(state, params) {
      state.botInfo = {
        ...state.botInfo,
        ...params
      };
    },
    updateBaseBotInfo(state, params) {
      state.updateBotBaseInfo = {
        ...state.updateBotBaseInfo,
        ...params
      };
    }
  },
  actions: {},
  getters: {
    botSettingInfo: state => state.botInfo,
    updateBotBaseInfo: state => state.updateBotBaseInfo
  }
};

export default app;
